<template>
  <div class="password-validator">
    <div class="password-rules">
      <div class="password-rule">
        <span class="icon is-small">
          <i
            class="fas fa-check-circle"
            :class="checkMinLength ? 'has-text-success' : defaultIconColor"></i>
        </span>
        <span
          :style="{ fontSize: textSize }"
          :class="defaultTextColor">{{ minLength }} caractères</span>
      </div>
      <div
        v-if="requireLowerCase"
        class="password-rule">
        <span class="icon is-small">
          <i
            class="fas fa-check-circle"
            :class="checkLowerCase ? 'has-text-success' : defaultIconColor"></i>
        </span>
        <span
          :style="{ fontSize: textSize }"
          :class="defaultTextColor">1 minuscule</span>
      </div>
      <div class="password-rule">
        <span class="icon is-small">
          <i
            class="fas fa-check-circle"
            :class="checkUpperCase ? 'has-text-success' : defaultIconColor"></i>
        </span>
        <span
          :style="{ fontSize: textSize }"
          :class="defaultTextColor">1 majuscule</span>
      </div>
      <div class="password-rule">
        <span class="icon is-small">
          <i
            class="fas fa-check-circle"
            :class="checkNumber ? 'has-text-success' : defaultIconColor"></i>
        </span>
        <span
          :style="{ fontSize: textSize }"
          :class="defaultTextColor">1 chiffre</span>
      </div>
      <div class="password-rule">
        <span class="icon is-small">
          <i
            class="fas fa-check-circle"
            :class="checkSpecialChar ? 'has-text-success' : defaultIconColor"></i>
        </span>
        <span
          :style="{ fontSize: textSize }"
          :class="defaultTextColor">1 caractère spécial</span>
      </div>
      <div
        v-if="showConfirmation"
        class="password-rule">
        <span class="icon is-small">
          <i
            class="fas fa-check-circle"
            :class="checkPasswordsMatch ? 'has-text-success' : defaultIconColor"></i>
        </span>
        <span
          :style="{ fontSize: textSize }"
          :class="defaultTextColor">Identique</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordValidator',
  props: {
    password: {
      type: String,
      default: null
    },
    confirmPassword: {
      type: String,
      default: null
    },
    minLength: {
      type: Number,
      default: 12
    },
    requireLowerCase: {
      type: Boolean,
      default: true
    },
    showConfirmation: {
      type: Boolean,
      default: false
    },
    textSize: {
      type: String,
      default: '0.875rem'
    },
    defaultColor: {
      type: String,
      default: 'grey',
      validator: (value) => ['grey', 'black'].includes(value)
    }
  },
  data () {
    return {
      checkMinLength: false,
      checkLowerCase: false,
      checkUpperCase: false,
      checkNumber: false,
      checkSpecialChar: false,
      checkPasswordsMatch: false
    }
  },
  computed: {
    isValid () {
      let basicValidation = this.checkMinLength && this.checkUpperCase && this.checkNumber && this.checkSpecialChar

      if (this.requireLowerCase) {
        basicValidation = basicValidation && this.checkLowerCase
      }

      if (this.showConfirmation) {
        return basicValidation && this.checkPasswordsMatch
      }

      return basicValidation
    },
    defaultTextColor () {
      return this.defaultColor === 'black' ? 'has-text-black' : 'has-text-grey'
    },
    defaultIconColor () {
      return this.defaultColor === 'black' ? 'has-text-black-light' : 'has-text-grey-light'
    }
  },
  watch: {
    password: {
      handler () {
        this.validatePassword()
      },
      immediate: true
    },
    confirmPassword: {
      handler () {
        this.validatePasswordMatch()
      },
      immediate: true
    },
    isValid: {
      handler (newVal) {
        this.$emit('validation-changed', newVal)
      },
      immediate: true
    }
  },
  methods: {
    validatePassword () {
      const pwd = this.password || ''
      this.checkMinLength = pwd.length >= this.minLength
      this.checkLowerCase = /[a-z]/.test(pwd)
      this.checkUpperCase = /[A-Z]/.test(pwd)
      this.checkNumber = /\d/.test(pwd)
      this.checkSpecialChar = /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/'`;~]/.test(pwd)
      this.validatePasswordMatch()
    },
    validatePasswordMatch () {
      if (this.showConfirmation) {
        const pwd = this.password || ''
        const confirm = this.confirmPassword || ''
        this.checkPasswordsMatch = pwd.length > 0 && pwd === confirm
      }
    }
  }
}
</script>

<style scoped>
.password-validator {
  font-size: 0.875rem;
}

.password-rules {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.password-rule {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  transition: all 0.3s ease;
}

.password-rule .icon {
  width: 1rem;
  height: 1rem;
}

.password-rule span {
  font-size: 0.875rem;
}
</style>
